// This value is populated by webpack at build time using 'Define' plugin.
// Cos we are using Typescript this file will be transpiled. Its really important that
// this file has no Import or Export statemates so the var stays in Global Scope!
// Basically, mitts off!
let API_URL: string = '';
let APP_RedirectURI: string = ''; 
let APP_ClientID: string = '';
let API_SCOPES: string = '';